exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".purchase-order-show .loader{margin-top:100px}.purchase-order-show .cancel-btn,.purchase-order-show .save-btn{margin-right:10px}.purchase-order-show .purchase-order-actions{margin-bottom:20px}", ""]);

// exports
